module.exports = __webpack_public_path__ + "img/magento-custom-development.0ebb8865.webp";